<template>
  <div>
    <v-card flat class="mt-5">
      <h5>GU-Intyg</h5>

      <v-data-table
        :headers="[
          {text: 'YRKE', sortable: false, filterable: false, value: 'professionId', width: '220'},
          {text: 'EXAMENSÅR', sortable: false, filterable: false, value: 'examYear', width: '120'},
          {text: 'UTFÄRDAT', sortable: false, filterable: false, value: 'createdAt', width: '120'},
          {text: 'UTFÄRDARE', filterable: false, value: 'regionId', width: '170'},
          {text: 'STATUS', sortable: false, filterable: false, value: 'approvedOn', width: '160'},
          {text: '', filterable: false, value: 'actions'}
        ]"
        :items="educationsList"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        hide-default-footer
        item-key="id"
      >
        <template slot="item.professionId" slot-scope="props">
          {{ getProfessionNameById(props.item.professionId) }}
        </template>
        <template slot="item.examYear" slot-scope="props">
          <template v-if="props.item.extendedInfo && props.item.extendedInfo.examYear">
            {{ getYear(props.item.extendedInfo.examYear) }}
          </template>
        </template>
        <template slot="item.createdAt" slot-scope="props">{{ props.item.createdAt | date }}</template>
        <template slot="item.regionId" slot-scope="props">
          {{ getRegionNameById(Number(props.item.regionId)) }}
        </template>

        <template slot="item.approvedOn" slot-scope="props">
          <span v-if="!showApprove(props.item) && !certificateIsApproved(props.item)" class="small">
            Väntar på godkännande av annan regionär.
          </span>
          <span v-if="certificateIsApproved(props.item)" class="small">
            Godkänd.
          </span>
        </template>
        <template slot="item.actions" slot-scope="props">
          <div class="d-flex justify-end">

            <v-btn
              v-if="showApprove(props.item) && !certificateIsApproved(props.item)"
              class="ml-2"
              @click="
                edMode = 'approve'
                edModalObj = props.item
                ;(edModal = true), getApplication(props.item)
              "
              :disabled="!canEducationUpdate"
            >
              <v-icon>$sl-like</v-icon>Godkänn
            </v-btn>

            <v-btn
              class="ml-4"
              color="secondary"
              @click="
                edMode = 'show'
                edModalObj = props.item
                ;(edModal = true), getApplication(props.item)
              "
              >Visa / Ändra
            </v-btn>

          </div>
        </template>
      </v-data-table>

      <v-dialog v-model="edModal" :max-width="720">
        <EducationModal
          v-if="edModalObj"
          @approve="approve"
          :title="edMode == 'approve' ? 'Godkänn GU-Intyg ' : 'GU-Intyg'"
          :person="selectedPerson"
          :propEducation="edModalObj"
          :propCourses="courses"
          :documents="documents"
          :propMachines="[]"
          :educationId="edModalObj.id"
          :selMachines="
            edModalObj.extendedInfo && edModalObj.extendedInfo.professionOrientations
              ? edModalObj.extendedInfo.professionOrientations
              : []
          "
          :propProfession="{id: edModalObj.professionId, name: getProfessionNameById(edModalObj.professionId)}"
          @create="create"
          @delete="deleteExemption"
          @edit="editExemption"
          @refuse="edModal = false; refreshPersonList(); refuseApplication(...arguments)"
          @close="
            edModal = false
            refreshPersonList()
          "
          :mode="edMode"
        />
      </v-dialog>

    </v-card>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import API from '@/services/api'
import EducationModal from '@/components/common/Education/EducationModal'
import {pageSize} from '@/store/constants'
import filter from 'lodash/filter'
import {RulesMixin, UserRules, CanIDo} from '@/components/mixins'
const SugarDate = require('sugar/date')
// @group Person
// PersonInstructorExemptions component
export default {
  name: 'PersonInstructorExemptions',
  mixins: [RulesMixin, UserRules, CanIDo],
  props: {
    initialMode: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    edModal: false,
    edMode: '',
    edModalObj: {},
    itemsPerPage: pageSize,
    educations: [],
    courses: [],
    documents: []
  }),
  created() {
    this.init()
  },
  components: {
    EducationModal
  },
  watch: {
    initialMode(newValue) {
      if (this.initialMode == 'GU-Intyg') {
        this.edMode = 'create'
        this.edModal = true
      }
    }
  },

  computed: {
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),
    ...mapGetters('basic', ['getProfessionNameById', 'basicRegions', 'getRegionNameById', 'approvedByByn']),

    educationsList() {
      if (this.selectedPerson && this.selectedPerson.educations) {        
        return filter(this.selectedPerson.educations, function(elem) { return elem.basicEducationCertificate !== null; })        
      }
    }
  },

  asyncComputed: {
    canEducationUpdate(){
      return this.canIDo('education', 'update');
    },
  },

  methods: {
    ...mapActions('person', ['setSelectedPerson']),
    ...mapActions('application', ['setSelectedApplication']),

    init() {},
    canApprove(ie) {
      return Boolean(
        (!ie.basicEducationCertificate.approvedAt &&
          ie.basicEducationCertificate.approvedById !== this.currentUser.id &&
          (this.currentUser.userrole.isAdmin || this.currentUser.userrole.isRegistry)) ||
          !this.currentUser.userrole.isRegionary ||
          (this.currentUser.userrole.isRegionary && this.currentUser.regionIds.includes(ie.regionId))
      )
    },
    certificateIsApproved(c) {
      if (c && c.basicEducationCertificate && c.basicEducationCertificate.approved) {
        return true
      }
      return false
    },
    getYear(date) {
      if (!date) return ''
      return SugarDate.Date(date).format('%Y')
    },
    /**
     * @vuese
     * Used to create instructor exemption
     * @arg The argument is object values representing instructor exemption
     */
    async create(ie) {
      this.edModal = false

      ie.personId = this.selectedPerson.id
      const res = await this.$dialog.confirm({
        text: `Dispens för ${this.selectedPerson.firstName} ${this.selectedPerson.lastName}`,
        title: 'Vill du verkligen godkänna?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel', outlined: true},
          {text: 'Utfärda', key: true, icon: '$sl-check'}
        ]
      })
      if (res !== true) return

      API.createInstructorExemptions({data: ie})
        .then(res => {
          /**
           * @vuese
           * Used to fetch person
           * @arg The argument is integer values representing person id
           */
          if (res && res.data && res.data.personId) {
            API.getPerson(res.data.personId)
              .then(response => {
                /**
                 * @vuese
                 * Used to update local store with the person data
                 * @arg the argument is an object representing person
                 */
                this.setSelectedPerson(response.data)
              })
              .catch(error => {
                console.log('There was an error:', error)
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    /**
     * @vuese
     * Used to approve instructor exemption
     * @arg The argument is integer values representing person who approved
     */
    approve(ie) {
      this.edModal = false

      if (!this.canApprove(ie)) {
        this.$events.fire('showError', 'Du saknar behörighet att godkänna detta utfärdande.')
        return
      }

      API.approveInstructorExemptions(ie.id)
        .then(res => {
          ie.approvedBy = {}
          ie.approvedOn = new Date()
          ie.approvedById = this.currentUser.id
          ie.approvedBy.id = this.currentUser.id
          ie.approvedBy.firstName = this.currentUser.firstName
          ie.approvedBy.lastName = this.currentUser.lastName
          this.$events.fire('showInfo', 'Sparad.')
        })
        .catch(error => {
          console.log(error)
        })
    },

    editExemption(ie) {
      this.edModal = false
      let prepareData = {
        id: ie.id,
        exemptionReason: ie.exemptionReason ? ie.exemptionReason : null,
        professionId: ie.professionId ? ie.professionId : null
      }
      API.updateExemption(prepareData.id, {data: prepareData})
        .then(res => {
          if (res && res.data && res.data.updatedRows) {
            API.getPerson(this.selectedPerson.id)
              .then(response => {
                if (response && response.data) {
                  this.selectedPerson.instructorExemptions = response.data.instructorExemptions
                }
              })
              .catch(error => {
                this.$events.fire(
                  'showError',
                  'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.'
                )
              })
          }

          this.$events.fire('showInfo', 'Uppdaterad.')
        })
        .catch(error => {
          console.log(error)
        })
    },
    async deleteExemption(ie) {
      this.edModal = false

      const res = await this.$dialog.confirm({
        text: 'Radering av dispen går inte att ångra.',
        title: `Vill du radera dispens för ${this.selectedPerson.firstName} ${this.selectedPerson.lastName}?`,
        actions: [
          {text: 'Radera', key: true},
          {text: 'Avbryt', key: false, icon: '$sl-cancel', outlined: true}
        ]
      })
      if (res !== true || (!ie && !ie.id)) return

      API.deleteExemption(ie.id)
        .then(res => {
          this.selectedPerson.instructorExemptions
          this.selectedPerson.instructorExemptions.splice(this.selectedPerson.instructorExemptions.indexOf(ie), 1)
          this.selectedPerson.instructorExemptions = [...this.selectedPerson.instructorExemptions]
          this.$events.fire('showInfo', 'Raderad.')
        })
        .catch(error => {
          console.log(error)
        })
    },
    showApprove(item) {
      if (item && item.regionId && item.basicEducationCertificate && item.basicEducationCertificate.createdById) {
        return this.canUserApprove(item.regionId, item.basicEducationCertificate.createdById)
      }
      return false
    },
    async getApplication(e) {
      if (!(e && e.application && e.application.id)) return
      await API.getApplication(e.application.id)
        .then(response => {
          this.courses = response.data.applicationCourses
          this.documents = response.data.applicationDocuments
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    refreshPersonList() {
      /**
       * @vuese
       * Used to fetch person
       * @arg The argument is integer values representing person id
       */
      API.getPerson(this.selectedPerson.id)
        .then(response => {
          /**
           * @vuese
           * Used to update local store with the person data
           * @arg the argument is an object representing person
           */
          this.setSelectedPerson(response.data)
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    async refuseApplication(id) {
      console.log('PersonEducation - refuseApplication', id)

      const res = await this.$dialog.confirm({
        text: 'Grundutbildningen måste nekas från dess anmälan. Du behöver öppna anmälan och neka den från sektionen Kurser från grundutbildning. Vill du öppna anmälan?',
        title: 'Neka anmälan?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel', outlined: true},
          {text: 'Öppna anmälan', key: true, icon: '$sl-check'}
        ]
      })

      if (res !== true) return

      await this.setSelectedApplication(null)
      await this.$router.push({name: 'Application', params: {id: id}})
    },
  }
}
</script>

<style>
</style>